import { ExaminationGrade } from "../../../Examination/Enums/ExaminationGrade";

export class ExaminationHistory {
    examinationId: number;
    examineeId: number;
    certificationId: number;
    title: string;
    certificationName: string;
    moduleSelection: string;
    formattedCnpType: string;
    startDate: string;
    endDate: string;
    releaseGrades: boolean;
    isPrimary: boolean;
    isMoc: boolean;
    hasExamineeDocuments: boolean;
    examinationGrade: ExaminationGrade;
    examineeStatusReason: string;
    examineeStatus: ExamineeStatus;
    examineeStatusReasonId: ExamineeStatusReason;
    candidateStatus: CandidateStatus
    candidateStatusReason: string;
}

export enum ExamineeStatus {
    UnexcusedAbsence = 26
}

export enum ExamineeStatusReason {
    Invalidated = 3
}

export enum CandidateStatus {
    ToBeReviewed = 1,
    Hold = 2,
    Denied = 3,
    Approved = 4,
    TransferredOut = 5,
    Withdrawn = 6,
    Unsubmitted = 8
}